import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class IntervalService {
  intervalId: number;

  setInterval(callback: () => Promise<void>, ms: number): void {
    this.intervalId = window.setInterval(() => callback(), ms);
  }

  clearInterval() {
    window.clearInterval(this.intervalId);
  }
}
